import React, { useState, useEffect, useRef } from 'react';

const SUPABASE_URL = 'https://ubfkhtkmlvutwdivmoff.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InViZmtodGttbHZ1dHdkaXZtb2ZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA4MTc5NTUsImV4cCI6MjA2NjM5Mzk1NX0.c0iRma-dnlL29OR3ffq34nmZuj_ViApBTMG-6PEX_B4';

const MODULOS = [
  { id: 'dashboard', name: 'Tablero' },
  { id: 'socios', name: 'Socios' },
  { id: 'ahorros', name: 'Ahorros' },
  { id: 'prestamos', name: 'Préstamos' },
  { id: 'pagos', name: 'Pagos' },
  { id: 'retiros', name: 'Retiros' },
  { id: 'reportes', name: 'Reportes' },
  { id: 'digital', name: 'Centro Digital' },
  { id: 'multas-renovaciones', name: 'Multas y Renovaciones' },
  { id: 'usuarios', name: 'Control Usuarios' },
  { id: 'afore-dashboard', name: 'AFORE Dashboard' },
  { id: 'afore-afiliados', name: 'AFORE Afiliados' },
];

const defaultForm = {
  nombre: '',
  usuario: '',
  email: '',
  contrasena: '',
  rol: 'usuario',
  id_socio: '',
  activo: true,
};

const UsuariosModule = () => {
  const [usersList, setUsersList] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [selectedPerms, setSelectedPerms] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  // ================= PIN ADMINISTRATIVO =================

const [showPinModal, setShowPinModal] =
  useState(false);

const [usuarioPinTarget, setUsuarioPinTarget] =
  useState(null);

const [pinAutorizador, setPinAutorizador] =
  useState('');

const [nuevoPinAdmin, setNuevoPinAdmin] =
  useState('');

const [confirmarNuevoPinAdmin, setConfirmarNuevoPinAdmin] =
  useState('');

const [guardandoPin, setGuardandoPin] =
  useState(false);

const [errorPin, setErrorPin] =
  useState('');

const [pinesConfigurados, setPinesConfigurados] =
  useState({});

  const [mostrarPinAutorizador, setMostrarPinAutorizador] =
  useState(false);

const [mostrarNuevoPin, setMostrarNuevoPin] =
  useState(false);

const [mostrarConfirmacionPin, setMostrarConfirmacionPin] =
  useState(false);

  // ================= ACCESO CONTROL USUARIOS =================

const [usuariosAutorizado, setUsuariosAutorizado] =
  useState(false);

const [pinAccesoUsuarios, setPinAccesoUsuarios] =
  useState('');

const [validandoAccesoUsuarios, setValidandoAccesoUsuarios] =
  useState(false);

const [errorAccesoUsuarios, setErrorAccesoUsuarios] =
  useState('');

const [mostrarPinAccesoUsuarios, setMostrarPinAccesoUsuarios] =
  useState(false);

  const formularioUsuarioRef = useRef(null);

useEffect(() => {

  if (usuariosAutorizado) {
    fetchUsers();
  }

}, [usuariosAutorizado]);

  const headers = {
    'Content-Type': 'application/json',
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  };

  // ======================================================
// ============== USUARIO ACTUAL / ADMIN ================
// ======================================================

const currentUser = (() => {
  try {
    return JSON.parse(
      localStorage.getItem('currentUser')
    ) || {};
  } catch {
    return {};
  }
})();

const currentUserId =
  currentUser?.id_usuario ||
  currentUser?.id ||
  null;

// ======================================================
// ========== VALIDAR ACCESO CONTROL USUARIOS ===========
// ======================================================

const validarAccesoUsuarios = async () => {

  const pinLimpio =
    String(pinAccesoUsuarios || '').trim();


  // Validar usuario actual
  if (!currentUserId) {

    setErrorAccesoUsuarios(
      'No se pudo identificar al usuario que inició sesión.'
    );

    return;
  }


  // PIN exactamente de 6 números
  if (!/^\d{6}$/.test(pinLimpio)) {

    setErrorAccesoUsuarios(
      'Ingrese un PIN válido de 6 dígitos.'
    );

    return;
  }


  setValidandoAccesoUsuarios(true);

  setErrorAccesoUsuarios('');


  try {

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/validar_pin_prestamos`,
      {
        method: 'POST',

        headers,

        body: JSON.stringify({

          p_usuario_ref:
            String(currentUserId),

          p_pin:
            pinLimpio,

        }),
      }
    );


    if (!response.ok) {

      const texto =
        await response.text();

      let mensaje =
        'No se pudo validar el PIN.';


      try {

        const obj =
          JSON.parse(texto);

        mensaje =
          obj?.message ||
          mensaje;

      } catch {
        // dejamos mensaje general
      }


      throw new Error(
        mensaje
      );

    }


    const resultado =
      await response.json();


    if (resultado !== true) {

      throw new Error(
        'PIN de administrador incorrecto.'
      );

    }


    // ================= PIN CORRECTO =================

    setUsuariosAutorizado(true);

    setPinAccesoUsuarios('');

    setErrorAccesoUsuarios('');


  } catch (err) {

    setErrorAccesoUsuarios(
      err.message ||
      'PIN de administrador incorrecto.'
    );


  } finally {

    setValidandoAccesoUsuarios(false);

  }

};
  
// ======================================================
// ============= ESTADO DE PINES ADMIN ==================
// ======================================================

const fetchPinStatus = async () => {

  try {

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/listar_estado_pines_admin`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify({}),
      }
    );

    if (!response.ok) {
      console.error(
        'No se pudo consultar el estado de los PIN.'
      );
      return;
    }

    const data = await response.json();

    const mapaPines = {};

    (Array.isArray(data) ? data : []).forEach((item) => {

      mapaPines[item.usuario_ref] =
        item.configurado === true &&
        item.activo !== false;

    });

    setPinesConfigurados(mapaPines);

  } catch (err) {

    console.error(
      'Error consultando estado de PIN:',
      err
    );

  }

};
  
  const fetchUsers = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${SUPABASE_URL}/rest/v1/usuarios_sistema?select=*&order=id_usuario.asc`, {
        headers,
      });

      if (!response.ok) throw new Error('Error al cargar usuarios');

      const data = await response.json();
      setUsersList(data);
      await fetchPinStatus();

      const permRes = await fetch(`${SUPABASE_URL}/rest/v1/permisos_modulos_fondo?select=*`, {
        headers,
      });

      if (permRes.ok) {
        const permData = await permRes.json();
        const grouped = {};

        permData.forEach((p) => {
          if (!grouped[p.id_usuario]) grouped[p.id_usuario] = {};
          grouped[p.id_usuario][p.modulo] = p;
        });

        setPermissions(grouped);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setForm(defaultForm);
    setSelectedPerms({});
    setEditingUser(null);
    setShowForm(false);
    setError(null);
  };

 const openNewForm = () => {
  resetForm();
  setShowForm(true);

  setTimeout(() => {
    formularioUsuarioRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, 100);
};

  const openEditForm = (user) => {
    setEditingUser(user);
    setForm({
      nombre: user.nombre || '',
      usuario: user.usuario || '',
      email: user.email || '',
      contrasena: user.contrasena || '',
      rol: user.rol || 'usuario',
      id_socio: user.id_socio || '',
      activo: user.activo !== false,
    });

    const userPerms = permissions[user.id_usuario] || {};
    const loaded = {};

    MODULOS.forEach((m) => {
      loaded[m.id] = {
        puede_ver: userPerms[m.id]?.puede_ver || false,
        puede_crear: userPerms[m.id]?.puede_crear || false,
        puede_editar: userPerms[m.id]?.puede_editar || false,
        puede_eliminar: userPerms[m.id]?.puede_eliminar || false,
      };
    });

    setSelectedPerms(loaded);
setShowForm(true);

setTimeout(() => {
  formularioUsuarioRef.current?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}, 100);

};

  const togglePerm = (modulo, permiso) => {
    setSelectedPerms((prev) => ({
      ...prev,
      [modulo]: {
        puede_ver: false,
        puede_crear: false,
        puede_editar: false,
        puede_eliminar: false,
        ...(prev[modulo] || {}),
        [permiso]: !(prev[modulo]?.[permiso] || false),
      },
    }));
  };

  const savePermissions = async (idUsuario) => {
    await fetch(`${SUPABASE_URL}/rest/v1/permisos_modulos_fondo?id_usuario=eq.${idUsuario}`, {
      method: 'DELETE',
      headers,
    });

    const rows = Object.entries(selectedPerms)
      .filter(([, p]) => p.puede_ver || p.puede_crear || p.puede_editar || p.puede_eliminar)
      .map(([modulo, p]) => ({
        id_usuario: idUsuario,
        modulo,
        puede_ver: !!p.puede_ver,
        puede_crear: !!p.puede_crear,
        puede_editar: !!p.puede_editar,
        puede_eliminar: !!p.puede_eliminar,
      }));

    if (rows.length === 0) return;

    await fetch(`${SUPABASE_URL}/rest/v1/permisos_modulos_fondo`, {
      method: 'POST',
      headers: {
        ...headers,
        Prefer: 'return=minimal',
      },
      body: JSON.stringify(rows),
    });
  };

// ======================================================
// ================= ABRIR PIN ADMIN =====================
// ======================================================

const abrirGestionPin = (user) => {

  const rol =
    String(user?.rol || '')
      .toLowerCase();

  if (
    ![
      'admin',
      'administrador',
      'superadmin'
    ].includes(rol)
  ) {

    alert(
      'El PIN de autenticación solamente aplica a administradores.'
    );

    return;
  }

  setUsuarioPinTarget(user);

  setPinAutorizador('');

  setNuevoPinAdmin('');

  setConfirmarNuevoPinAdmin('');

  setErrorPin('');

  setShowPinModal(true);

};

// ======================================================
// ============== GUARDAR / CAMBIAR PIN =================
// ======================================================

const guardarPinAdministrador = async () => {

  if (!usuarioPinTarget?.id_usuario) {

    setErrorPin(
      'No se pudo identificar al usuario.'
    );

    return;
  }


  if (!currentUserId) {

    setErrorPin(
      'No se pudo identificar al administrador que inició sesión.'
    );

    return;
  }


  const pinActual =
    String(pinAutorizador || '')
      .trim();


  const nuevoPin =
    String(nuevoPinAdmin || '')
      .trim();


  const confirmarPin =
    String(confirmarNuevoPinAdmin || '')
      .trim();


  if (!/^\d{6}$/.test(pinActual)) {

    setErrorPin(
      'Ingrese su PIN administrativo actual de 6 dígitos.'
    );

    return;
  }


  if (!/^\d{6}$/.test(nuevoPin)) {

    setErrorPin(
      'El nuevo PIN debe contener exactamente 6 dígitos.'
    );

    return;
  }


  if (nuevoPin !== confirmarPin) {

    setErrorPin(
      'La confirmación del nuevo PIN no coincide.'
    );

    return;
  }


  setGuardandoPin(true);

  setErrorPin('');


  try {

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/gestionar_pin_admin_prestamos`,
      {
        method: 'POST',

        headers,

        body: JSON.stringify({

          p_usuario_actual_ref:
            String(currentUserId),

          p_pin_actual:
            pinActual,

          p_usuario_destino_ref:
            String(
              usuarioPinTarget.id_usuario
            ),

          p_pin_nuevo:
            nuevoPin,

        }),
      }
    );


    if (!response.ok) {

      const texto =
        await response.text();

      let mensaje =
        'No se pudo guardar el PIN.';


      try {

        const datos =
          JSON.parse(texto);

        mensaje =
          datos?.message ||
          mensaje;

      } catch {
        // usamos mensaje general
      }


      throw new Error(
        mensaje
      );

    }


    setPinesConfigurados(
      (prev) => ({
        ...prev,
        [usuarioPinTarget.id_usuario]:
          true,
      })
    );


    setShowPinModal(false);

    setUsuarioPinTarget(null);

    setPinAutorizador('');

    setNuevoPinAdmin('');

    setConfirmarNuevoPinAdmin('');

    setErrorPin('');


  } catch (err) {

    setErrorPin(
      err.message ||
      'No se pudo cambiar el PIN.'
    );

  } finally {

    setGuardandoPin(false);

  }

};
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);

    try {
      const payload = {
        nombre: form.nombre || null,
        usuario: form.usuario || form.email.split('@')[0],
        email: form.email,
        contrasena: form.contrasena,
        rol: form.rol,
        id_socio: form.id_socio || null,
        activo: form.activo,
      };

      let idUsuario;

      if (editingUser) {
        const res = await fetch(`${SUPABASE_URL}/rest/v1/usuarios_sistema?id_usuario=eq.${editingUser.id_usuario}`, {
          method: 'PATCH',
          headers: {
            ...headers,
            Prefer: 'return=representation',
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || 'No se pudo actualizar usuario');
        }

        const data = await res.json();
        idUsuario = data[0].id_usuario;
      } else {
        const res = await fetch(`${SUPABASE_URL}/rest/v1/usuarios_sistema`, {
          method: 'POST',
          headers: {
            ...headers,
            Prefer: 'return=representation',
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || 'No se pudo crear usuario');
        }

        const data = await res.json();
        idUsuario = data[0].id_usuario;
      }

      await savePermissions(idUsuario);
      await fetchUsers();
      resetForm();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const deleteUser = async (user) => {
    if (!window.confirm(`¿Eliminar usuario ${user.email}?`)) return;

    setSaving(true);
    try {
      await fetch(`${SUPABASE_URL}/rest/v1/permisos_modulos_fondo?id_usuario=eq.${user.id_usuario}`, {
        method: 'DELETE',
        headers,
      });

      await fetch(`${SUPABASE_URL}/rest/v1/usuarios_sistema?id_usuario=eq.${user.id_usuario}`, {
        method: 'DELETE',
        headers,
      });

      await fetchUsers();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const filteredUsers = usersList.filter((user) =>
    `${user.email || ''} ${user.rol || ''} ${user.nombre || ''}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
// ======================================================
// ============ BLOQUEO CONTROL DE USUARIOS =============
// ======================================================

if (!usuariosAutorizado) {

  return (

    <div className="p-4 md:p-6 bg-slate-50 min-h-full">

      <div className="max-w-md mx-auto mt-8 bg-white border border-slate-200 rounded-2xl shadow-lg overflow-hidden">


        {/* ENCABEZADO */}
        <div className="p-6 text-center border-b border-slate-200">

          <div className="w-16 h-16 mx-auto rounded-2xl bg-purple-100 flex items-center justify-center text-3xl mb-4">
            🔐
          </div>

          <h2 className="text-2xl font-bold text-slate-900">
            Control de Usuarios
          </h2>

          <p className="text-sm text-slate-500 mt-2">
            Esta sección contiene información sensible.
            Ingrese su PIN administrativo para continuar.
          </p>

        </div>


        {/* CUERPO */}
        <div className="p-6">

          <label className="block text-sm font-semibold text-slate-700 mb-2">
            PIN de Autenticación
          </label>


          <div className="relative">

            <input
              type={
                mostrarPinAccesoUsuarios
                  ? 'text'
                  : 'password'
              }
              inputMode="numeric"
              maxLength={6}
              autoComplete="off"
              value={pinAccesoUsuarios}
              onChange={(e) => {

                setPinAccesoUsuarios(
                  e.target.value
                    .replace(/\D/g, '')
                    .slice(0, 6)
                );

                setErrorAccesoUsuarios('');

              }}
              onKeyDown={(e) => {

                if (e.key === 'Enter') {
                  validarAccesoUsuarios();
                }

              }}
              placeholder="••••••"
              className="
                w-full
                border
                border-slate-300
                rounded-xl
                px-4
                py-3
                pr-12
                text-center
                text-xl
                tracking-[0.4em]
              "
            />


            {/* OJITO */}
            <button
              type="button"
              onClick={() =>
                setMostrarPinAccesoUsuarios(
                  !mostrarPinAccesoUsuarios
                )
              }
              className="
                absolute
                right-3
                top-1/2
                -translate-y-1/2
                text-slate-500
                hover:text-slate-800
              "
              title={
                mostrarPinAccesoUsuarios
                  ? 'Ocultar PIN'
                  : 'Mostrar PIN'
              }
            >

              {mostrarPinAccesoUsuarios
                ? '🙈'
                : '👁️'}

            </button>

          </div>


          {/* ERROR */}
          {errorAccesoUsuarios && (

            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">

              ⚠ {errorAccesoUsuarios}

            </div>

          )}


          {/* BOTÓN ENTRAR */}
          <button
            type="button"
            onClick={validarAccesoUsuarios}
            disabled={validandoAccesoUsuarios}
            className="
              w-full
              mt-5
              px-4
              py-3
              bg-purple-600
              text-white
              rounded-xl
              font-semibold
              hover:bg-purple-700
              disabled:opacity-50
            "
          >

            {validandoAccesoUsuarios
              ? 'Validando...'
              : 'Ingresar a Control de Usuarios'}

          </button>

        </div>

      </div>

    </div>

  );

}
  return (
    <div className="p-4 md:p-6 space-y-6 bg-slate-50 min-h-full">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900">Control de Usuarios</h2>
          <p className="text-slate-600 mt-1">Gestiona usuarios, roles y permisos por módulo.</p>
        </div>

        <button
          onClick={showForm ? resetForm : openNewForm}
          className="px-5 py-3 bg-purple-600 text-white rounded-xl shadow-md hover:bg-purple-700 transition-all font-medium"
        >
          {showForm ? 'Cancelar' : 'Nuevo Usuario'}
        </button>
      </div>

     {showForm && (
  <div
    ref={formularioUsuarioRef}
    className="bg-white rounded-2xl shadow-lg border border-slate-200 p-5 md:p-6 mb-6 scroll-mt-4"
  >
          <h3 className="text-xl font-semibold text-slate-900 mb-4">
            {editingUser ? 'Editar Usuario' : 'Registrar Nuevo Usuario'}
          </h3>

          {error && (
            <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Nombre"
                value={form.nombre}
                onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
              />

              <input
                type="text"
                placeholder="Usuario"
                value={form.usuario}
                onChange={(e) => setForm({ ...form, usuario: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
              />

              <input
                type="email"
                placeholder="Correo electrónico"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
                required
              />

              <input
                type="text"
                placeholder="Contraseña"
                value={form.contrasena}
                onChange={(e) => setForm({ ...form, contrasena: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
                required
              />

              <select
                value={form.rol}
                onChange={(e) => setForm({ ...form, rol: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
              >
                <option value="admin">Admin</option>
                <option value="supervisor">Supervisor</option>
                <option value="capturista">Capturista</option>
                <option value="usuario">Usuario / Socio</option>
              </select>

              <input
                type="number"
                placeholder="ID Socio (opcional)"
                value={form.id_socio}
                onChange={(e) => setForm({ ...form, id_socio: e.target.value })}
                className="px-4 py-3 border border-slate-200 rounded-xl"
              />

              <label className="flex items-center gap-3 px-4 py-3 border border-slate-200 rounded-xl">
                <input
                  type="checkbox"
                  checked={form.activo}
                  onChange={(e) => setForm({ ...form, activo: e.target.checked })}
                />
                Usuario activo
              </label>
                    {/* ====================================================== */}
{/* ============== PIN DE AUTENTICACIÓN ================== */}
{/* ====================================================== */}

{[
  'admin',
  'administrador',
  'superadmin'
].includes(
  String(form.rol || '')
    .toLowerCase()
) && (

  <div className="md:col-span-2 border border-purple-200 bg-purple-50 rounded-xl p-4">

    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

      <div>

        <p className="text-sm font-semibold text-slate-800">
          PIN de Autenticación
        </p>


        {editingUser ? (

          pinesConfigurados[editingUser.id_usuario] ? (

            <div className="mt-1">

              <span className="font-mono text-lg tracking-[0.3em] text-slate-800">
                ••••••
              </span>

              <span className="ml-3 inline-flex px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
                Configurado
              </span>

            </div>

          ) : (

            <p className="mt-1 text-sm text-orange-700 font-medium">
              Sin configurar
            </p>

          )

        ) : (

          <p className="mt-1 text-sm text-slate-500">
            Primero registre al administrador para poder asignarle un PIN.
          </p>

        )}

      </div>


      {editingUser && (

        <button
          type="button"
          onClick={() =>
            abrirGestionPin(editingUser)
          }
          className="w-full sm:w-auto px-4 py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700"
        >

          {pinesConfigurados[editingUser.id_usuario]
            ? 'Cambiar PIN'
            : 'Asignar PIN'}

        </button>

      )}

    </div>

  </div>

)}
            </div>

            <div>
              <h4 className="font-semibold text-slate-800 mb-3">Permisos por módulo</h4>

              <div className="overflow-x-auto border border-slate-200 rounded-xl">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="text-left p-3">Módulo</th>
                      <th className="p-3">Ver</th>
                      <th className="p-3">Crear</th>
                      <th className="p-3">Editar</th>
                      <th className="p-3">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {MODULOS.map((m) => (
                      <tr key={m.id} className="border-t border-slate-100">
                        <td className="p-3 font-medium text-slate-700">{m.name}</td>
                        {['puede_ver', 'puede_crear', 'puede_editar', 'puede_eliminar'].map((perm) => (
                          <td key={perm} className="p-3 text-center">
                            <input
                              type="checkbox"
                              checked={!!selectedPerms[m.id]?.[perm]}
                              onChange={() => togglePerm(m.id, perm)}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <button
              type="submit"
              disabled={saving}
              className="w-full md:w-auto px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 font-medium"
            >
              {saving ? 'Guardando...' : editingUser ? 'Actualizar Usuario' : 'Registrar Usuario'}
            </button>
          </form>
        </div>
      )}

{/* ====================================================== */}
{/* ============= PIN DE AUTENTICACIÓN =================== */}
{/* ====================================================== */}

{showPinModal && usuarioPinTarget && (

  <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-3">

    <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden">

      {/* ENCABEZADO */}
      <div className="p-5 border-b border-slate-200">

        <h3 className="text-xl font-bold text-slate-900">
          PIN de Autenticación
        </h3>

        <p className="text-sm text-slate-500 mt-1">
          {usuarioPinTarget.nombre ||
            usuarioPinTarget.email}
        </p>

        <p className="text-xs text-slate-400 mt-1">
          ID Usuario: {usuarioPinTarget.id_usuario}
        </p>

      </div>


      {/* CUERPO */}
      <div className="p-5 space-y-5">

        <div className="p-4 bg-purple-50 border border-purple-200 rounded-xl">

          <p className="font-semibold text-purple-800">
            Autorización administrativa
          </p>

          <p className="text-sm text-purple-700 mt-1">
            Para asignar o cambiar el PIN de otro administrador,
            primero debe ingresar su propio PIN administrativo.
          </p>

        </div>


        {/* PIN DEL ADMIN QUE AUTORIZA */}
        <div>

          <label className="block text-sm font-semibold text-slate-700 mb-1">
            Su PIN administrativo *
          </label>
<div className="relative">

  <input
    type={mostrarPinAutorizador ? 'text' : 'password'}
    inputMode="numeric"
    maxLength={6}
    autoComplete="off"
    value={pinAutorizador}
    onChange={(e) => {
      setPinAutorizador(
        e.target.value
          .replace(/\D/g, '')
          .slice(0, 6)
      );

      setErrorPin('');
    }}
    placeholder="••••••"
    className="w-full border border-slate-300 rounded-xl px-4 py-3 pr-12 text-center text-xl tracking-[0.4em]"
  />

  <button
    type="button"
    onClick={() =>
      setMostrarPinAutorizador(!mostrarPinAutorizador)
    }
    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-800"
    title={mostrarPinAutorizador ? 'Ocultar PIN' : 'Mostrar PIN'}
  >
    {mostrarPinAutorizador ? '🙈' : '👁️'}
  </button>

</div>
</div>

        {/* NUEVO PIN */}
        <div>

          <label className="block text-sm font-semibold text-slate-700 mb-1">
            Nuevo PIN de 6 dígitos *
          </label>

          <input
            type="password"
            inputMode="numeric"
            maxLength={6}
            autoComplete="off"
            value={nuevoPinAdmin}
            onChange={(e) => {

              setNuevoPinAdmin(
                e.target.value
                  .replace(/\D/g, '')
                  .slice(0, 6)
              );

              setErrorPin('');

            }}
            placeholder="••••••"
            className="
              w-full
              border border-slate-300
              rounded-xl
              px-4 py-3
              text-center
              text-xl
              tracking-[0.4em]
            "
          />

        </div>


        {/* CONFIRMACIÓN */}
        <div>

          <label className="block text-sm font-semibold text-slate-700 mb-1">
            Confirmar nuevo PIN *
          </label>

          <input
            type="password"
            inputMode="numeric"
            maxLength={6}
            autoComplete="off"
            value={confirmarNuevoPinAdmin}
            onChange={(e) => {

              setConfirmarNuevoPinAdmin(
                e.target.value
                  .replace(/\D/g, '')
                  .slice(0, 6)
              );

              setErrorPin('');

            }}
            placeholder="••••••"
            className="
              w-full
              border border-slate-300
              rounded-xl
              px-4 py-3
              text-center
              text-xl
              tracking-[0.4em]
            "
          />

        </div>


        {/* ERROR */}
        {errorPin && (

          <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">

            ⚠ {errorPin}

          </div>

        )}

      </div>


      {/* BOTONES */}
      <div className="p-4 border-t border-slate-200 flex flex-col sm:flex-row gap-3">

        <button
          type="button"
          disabled={guardandoPin}
          onClick={() => {

            setShowPinModal(false);
            setUsuarioPinTarget(null);
            setPinAutorizador('');
            setNuevoPinAdmin('');
            setConfirmarNuevoPinAdmin('');
            setErrorPin('');

          }}
          className="
            w-full
            px-4 py-3
            bg-slate-100
            text-slate-700
            rounded-xl
            font-medium
            hover:bg-slate-200
          "
        >
          Cancelar
        </button>


        <button
          type="button"
          disabled={guardandoPin}
          onClick={guardarPinAdministrador}
          className="
            w-full
            px-4 py-3
            bg-purple-600
            text-white
            rounded-xl
            font-semibold
            hover:bg-purple-700
            disabled:opacity-50
          "
        >

          {guardandoPin
            ? 'Guardando...'
            : 'Guardar nuevo PIN'}

        </button>

      </div>

    </div>

  </div>

)}
        
      <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-5 md:p-6">
        <div className="mb-6">
          <input
            type="text"
            placeholder="Buscar por email, nombre o rol..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl"
          />
        </div>

        {loading && <p className="text-center text-slate-600">Cargando usuarios...</p>}
        {error && !loading && <p className="text-center text-red-500">Error: {error}</p>}

        {!loading && !error && filteredUsers.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-slate-200 text-slate-700">
                  <th className="py-3 px-4">ID</th>
<th className="py-3 px-4">Email</th>
<th className="py-3 px-4">Rol</th>
<th className="py-3 px-4">Activo</th>
<th className="py-3 px-4">ID Socio</th>

<th className="py-3 px-4">
  PIN de Autenticación
</th>

<th className="py-3 px-4">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.id_usuario} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="py-4 px-4">{user.id_usuario}</td>
                    <td className="py-4 px-4 font-medium">{user.email}</td>
                    <td className="py-4 px-4">{user.rol}</td>
                    <td className="py-4 px-4">{user.activo === false ? 'No' : 'Sí'}</td>
                    <td className="py-4 px-4">{user.id_socio || 'N/A'}</td>
          <td className="py-4 px-4">

  {[
    'admin',
    'administrador',
    'superadmin'
  ].includes(
    String(user.rol || '')
      .toLowerCase()
  ) ? (

    <div className="flex flex-col items-start gap-1">

      <span className="font-mono text-slate-700">

        {pinesConfigurados[user.id_usuario]
          ? '••••••'
          : 'Sin configurar'}

      </span>

      <button
        type="button"
        onClick={() =>
          abrirGestionPin(user)
        }
        className="text-xs text-purple-600 hover:text-purple-800 font-medium"
      >

        {pinesConfigurados[user.id_usuario]
          ? 'Cambiar PIN'
          : 'Asignar PIN'}

      </button>

    </div>

  ) : (

    <span className="text-slate-400">
      No aplica
    </span>

  )}

</td>
                    <td className="py-4 px-4">
                      <div className="flex gap-2">
                        <button
                          onClick={() => openEditForm(user)}
                          className="px-3 py-2 text-blue-600 hover:bg-blue-50 rounded-lg"
                        >
                          Editar
                        </button>
                        <button
                          onClick={() => deleteUser(user)}
                          className="px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg"
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {!loading && !error && filteredUsers.length === 0 && (
          <p className="text-center text-slate-600">No hay usuarios registrados.</p>
        )}
      </div>
    </div>
  );
};

export default UsuariosModule;
